module.exports = __webpack_public_path__ + "static/media/paraguai.c4d35613.jpg";